// BEGIN motorbikeBackpackGalleryRestore20260716
;(function motorbikeBackpackGalleryRestore20260716() {
  var config = {
  "handle": "seibertron-b-a-r-pro-2-0-signature-baseball-softball-batting-gloves-wholesale",
  "entries": [
    {
      "id": "33460703330494",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-bar-pro-2-pink-white-background-main-20260717.jpg?v=1784258551",
      "alt": "color:Pink | role:white-background-main | Seibertron BAR PRO 2.0 pink baseball softball batting gloves white background main image"
    },
    {
      "id": "33373178233022",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/bar-pro-2-gallery-01.jpg?v=1783389965",
      "alt": "color:Pink | Seibertron B-A-R PRO 2.0 baseball and softball batting gloves image 01"
    },
    {
      "id": "33373178265790",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/bar-pro-2-gallery-02.jpg?v=1783389965",
      "alt": "color:Pink | Seibertron B-A-R PRO 2.0 baseball and softball batting gloves image 02"
    },
    {
      "id": "33373178298558",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/bar-pro-2-gallery-03.jpg?v=1783389965",
      "alt": "color:Pink | Seibertron B-A-R PRO 2.0 baseball and softball batting gloves image 03"
    },
    {
      "id": "33373178331326",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/bar-pro-2-gallery-04.jpg?v=1783389966",
      "alt": "color:white | Seibertron B-A-R PRO 2.0 baseball and softball batting gloves image 04"
    },
    {
      "id": "33373178364094",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/bar-pro-2-gallery-05.jpg?v=1783389965",
      "alt": "color:white | Seibertron B-A-R PRO 2.0 baseball and softball batting gloves image 05"
    },
    {
      "id": "33373178396862",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/bar-pro-2-gallery-06.jpg?v=1783389965",
      "alt": "color:white | Seibertron B-A-R PRO 2.0 baseball and softball batting gloves image 06"
    },
    {
      "id": "33373178429630",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/bar-pro-2-gallery-07.jpg?v=1783389965",
      "alt": "color:white | Seibertron B-A-R PRO 2.0 baseball and softball batting gloves image 07"
    },
    {
      "id": "33373178462398",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/bar-pro-2-gallery-08.jpg?v=1783389965",
      "alt": "color:Black | Seibertron B-A-R PRO 2.0 baseball and softball batting gloves image 08"
    },
    {
      "id": "33373178495166",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/bar-pro-2-gallery-09.jpg?v=1783389965",
      "alt": "color:Black | Seibertron B-A-R PRO 2.0 baseball and softball batting gloves image 09"
    },
    {
      "id": "33373178527934",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/bar-pro-2-gallery-10.jpg?v=1783389965",
      "alt": "color:Black | Seibertron B-A-R PRO 2.0 baseball and softball batting gloves image 10"
    },
    {
      "id": "33373178560702",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/bar-pro-2-gallery-11.jpg?v=1783389965",
      "alt": "color:Black | Seibertron B-A-R PRO 2.0 baseball and softball batting gloves image 11"
    },
    {
      "id": "33373178593470",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/bar-pro-2-gallery-12.jpg?v=1783389965",
      "alt": "color:red | Seibertron B-A-R PRO 2.0 baseball and softball batting gloves image 12"
    },
    {
      "id": "33373178626238",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/bar-pro-2-gallery-13.jpg?v=1783389965",
      "alt": "color:red | Seibertron B-A-R PRO 2.0 baseball and softball batting gloves image 13"
    },
    {
      "id": "33373178659006",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/bar-pro-2-gallery-14.jpg?v=1783389965",
      "alt": "color:red | Seibertron B-A-R PRO 2.0 baseball and softball batting gloves image 14"
    },
    {
      "id": "33373178691774",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/bar-pro-2-gallery-15.jpg?v=1783389965",
      "alt": "color:Yellow | Seibertron B-A-R PRO 2.0 baseball and softball batting gloves image 15"
    },
    {
      "id": "33373178724542",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/bar-pro-2-gallery-16.jpg?v=1783389966",
      "alt": "color:Yellow | Seibertron B-A-R PRO 2.0 baseball and softball batting gloves image 16"
    },
    {
      "id": "33373178757310",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/bar-pro-2-gallery-17.jpg?v=1783389965",
      "alt": "color:Yellow | Seibertron B-A-R PRO 2.0 baseball and softball batting gloves image 17"
    },
    {
      "id": "33461205336254",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-bar-pro-2-white-white-background-main-20260717.jpg?v=1784260047",
      "alt": "color:white | role:white-background-main | Seibertron BAR PRO 2.0 white baseball softball batting gloves white background main image"
    },
    {
      "id": "33461205369022",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-bar-pro-2-black-white-background-main-20260717.jpg?v=1784260047",
      "alt": "color:Black | role:white-background-main | Seibertron BAR PRO 2.0 black baseball softball batting gloves white background main image"
    },
    {
      "id": "33461205401790",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-bar-pro-2-red-white-background-main-20260717.jpg?v=1784260048",
      "alt": "color:red | role:white-background-main | Seibertron BAR PRO 2.0 red baseball softball batting gloves white background main image"
    },
    {
      "id": "33461205434558",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-bar-pro-2-yellow-white-background-main-20260717.jpg?v=1784260047",
      "alt": "color:Yellow | role:white-background-main | Seibertron BAR PRO 2.0 yellow baseball softball batting gloves white background main image"
    }
  ],
  "variants": [
    {
      "id": "42735659450558",
      "title": "Pink / Adult XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "Adult XS"
        }
      ],
      "values": [
        "Pink",
        "Adult XS"
      ],
      "mediaId": "33460703330494"
    },
    {
      "id": "42735659483326",
      "title": "Pink / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Pink",
        "Adult S"
      ],
      "mediaId": "33460703330494"
    },
    {
      "id": "42735659516094",
      "title": "Pink / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Pink",
        "Adult M"
      ],
      "mediaId": "33460703330494"
    },
    {
      "id": "42735659581630",
      "title": "Pink / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Pink",
        "Adult L"
      ],
      "mediaId": "33460703330494"
    },
    {
      "id": "42735659614398",
      "title": "Pink / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Pink",
        "Adult XL"
      ],
      "mediaId": "33460703330494"
    },
    {
      "id": "42735659647166",
      "title": "Pink / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Pink",
        "Adult XXL"
      ],
      "mediaId": "33460703330494"
    },
    {
      "id": "41897907323070",
      "title": "white / Adult XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "white"
        },
        {
          "name": "Size",
          "value": "Adult XS"
        }
      ],
      "values": [
        "white",
        "Adult XS"
      ],
      "mediaId": "33461205336254"
    },
    {
      "id": "41897907257534",
      "title": "white / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "white"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "white",
        "Adult S"
      ],
      "mediaId": "33461205336254"
    },
    {
      "id": "41897907224766",
      "title": "white / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "white"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "white",
        "Adult M"
      ],
      "mediaId": "33461205336254"
    },
    {
      "id": "41897907191998",
      "title": "white / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "white"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "white",
        "Adult L"
      ],
      "mediaId": "33461205336254"
    },
    {
      "id": "41897907290302",
      "title": "white / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "white"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "white",
        "Adult XL"
      ],
      "mediaId": "33461205336254"
    },
    {
      "id": "41897907355838",
      "title": "white / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "white"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "white",
        "Adult XXL"
      ],
      "mediaId": "33461205336254"
    },
    {
      "id": "41897907519678",
      "title": "Black / Adult XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult XS"
        }
      ],
      "values": [
        "Black",
        "Adult XS"
      ],
      "mediaId": "33461205369022"
    },
    {
      "id": "41897907454142",
      "title": "Black / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Black",
        "Adult S"
      ],
      "mediaId": "33461205369022"
    },
    {
      "id": "41897907421374",
      "title": "Black / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Black",
        "Adult M"
      ],
      "mediaId": "33461205369022"
    },
    {
      "id": "41897907388606",
      "title": "Black / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Black",
        "Adult L"
      ],
      "mediaId": "33461205369022"
    },
    {
      "id": "41897907486910",
      "title": "Black / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Black",
        "Adult XL"
      ],
      "mediaId": "33461205369022"
    },
    {
      "id": "41897907552446",
      "title": "Black / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Black",
        "Adult XXL"
      ],
      "mediaId": "33461205369022"
    },
    {
      "id": "41897907716286",
      "title": "red / Adult XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "red"
        },
        {
          "name": "Size",
          "value": "Adult XS"
        }
      ],
      "values": [
        "red",
        "Adult XS"
      ],
      "mediaId": "33461205401790"
    },
    {
      "id": "41897907650750",
      "title": "red / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "red"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "red",
        "Adult S"
      ],
      "mediaId": "33461205401790"
    },
    {
      "id": "41897907617982",
      "title": "red / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "red"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "red",
        "Adult M"
      ],
      "mediaId": "33461205401790"
    },
    {
      "id": "41897907585214",
      "title": "red / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "red"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "red",
        "Adult L"
      ],
      "mediaId": "33461205401790"
    },
    {
      "id": "41897907683518",
      "title": "red / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "red"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "red",
        "Adult XL"
      ],
      "mediaId": "33461205401790"
    },
    {
      "id": "41897907749054",
      "title": "red / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "red"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "red",
        "Adult XXL"
      ],
      "mediaId": "33461205401790"
    },
    {
      "id": "41897907912894",
      "title": "Yellow / Adult XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Yellow"
        },
        {
          "name": "Size",
          "value": "Adult XS"
        }
      ],
      "values": [
        "Yellow",
        "Adult XS"
      ],
      "mediaId": "33461205434558"
    },
    {
      "id": "41897907847358",
      "title": "Yellow / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Yellow"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Yellow",
        "Adult S"
      ],
      "mediaId": "33461205434558"
    },
    {
      "id": "41897907814590",
      "title": "Yellow / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Yellow"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Yellow",
        "Adult M"
      ],
      "mediaId": "33461205434558"
    },
    {
      "id": "41897907781822",
      "title": "Yellow / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Yellow"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Yellow",
        "Adult L"
      ],
      "mediaId": "33461205434558"
    },
    {
      "id": "41897907880126",
      "title": "Yellow / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Yellow"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Yellow",
        "Adult XL"
      ],
      "mediaId": "33461205434558"
    },
    {
      "id": "41897907945662",
      "title": "Yellow / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Yellow"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Yellow",
        "Adult XXL"
      ],
      "mediaId": "33461205434558"
    },
    {
      "id": "47904017383614",
      "title": "Pink / Youth XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "Youth XS"
        }
      ],
      "values": [
        "Pink",
        "Youth XS"
      ],
      "mediaId": "33460703330494"
    },
    {
      "id": "47904017416382",
      "title": "Pink / Youth S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "Youth S"
        }
      ],
      "values": [
        "Pink",
        "Youth S"
      ],
      "mediaId": "33460703330494"
    },
    {
      "id": "47904017449150",
      "title": "Pink / Youth M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "Youth M"
        }
      ],
      "values": [
        "Pink",
        "Youth M"
      ],
      "mediaId": "33460703330494"
    },
    {
      "id": "47904017481918",
      "title": "Pink / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Pink",
        "Youth L"
      ],
      "mediaId": "33460703330494"
    },
    {
      "id": "47904017514686",
      "title": "Pink / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Pink",
        "Youth XL"
      ],
      "mediaId": "33460703330494"
    },
    {
      "id": "47904017547454",
      "title": "white / Youth XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "white"
        },
        {
          "name": "Size",
          "value": "Youth XS"
        }
      ],
      "values": [
        "white",
        "Youth XS"
      ],
      "mediaId": "33461205336254"
    },
    {
      "id": "47904017580222",
      "title": "white / Youth S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "white"
        },
        {
          "name": "Size",
          "value": "Youth S"
        }
      ],
      "values": [
        "white",
        "Youth S"
      ],
      "mediaId": "33461205336254"
    },
    {
      "id": "47904017612990",
      "title": "white / Youth M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "white"
        },
        {
          "name": "Size",
          "value": "Youth M"
        }
      ],
      "values": [
        "white",
        "Youth M"
      ],
      "mediaId": "33461205336254"
    },
    {
      "id": "47904017645758",
      "title": "white / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "white"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "white",
        "Youth L"
      ],
      "mediaId": "33461205336254"
    },
    {
      "id": "47904017678526",
      "title": "white / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "white"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "white",
        "Youth XL"
      ],
      "mediaId": "33461205336254"
    },
    {
      "id": "47904017711294",
      "title": "Black / Youth XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Youth XS"
        }
      ],
      "values": [
        "Black",
        "Youth XS"
      ],
      "mediaId": "33461205369022"
    },
    {
      "id": "47904017744062",
      "title": "Black / Youth S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Youth S"
        }
      ],
      "values": [
        "Black",
        "Youth S"
      ],
      "mediaId": "33461205369022"
    },
    {
      "id": "47904017776830",
      "title": "Black / Youth M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Youth M"
        }
      ],
      "values": [
        "Black",
        "Youth M"
      ],
      "mediaId": "33461205369022"
    },
    {
      "id": "47904017809598",
      "title": "Black / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Black",
        "Youth L"
      ],
      "mediaId": "33461205369022"
    },
    {
      "id": "47904017842366",
      "title": "Black / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Black",
        "Youth XL"
      ],
      "mediaId": "33461205369022"
    },
    {
      "id": "47904017875134",
      "title": "red / Youth XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "red"
        },
        {
          "name": "Size",
          "value": "Youth XS"
        }
      ],
      "values": [
        "red",
        "Youth XS"
      ],
      "mediaId": "33461205401790"
    },
    {
      "id": "47904017907902",
      "title": "red / Youth S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "red"
        },
        {
          "name": "Size",
          "value": "Youth S"
        }
      ],
      "values": [
        "red",
        "Youth S"
      ],
      "mediaId": "33461205401790"
    },
    {
      "id": "47904017940670",
      "title": "red / Youth M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "red"
        },
        {
          "name": "Size",
          "value": "Youth M"
        }
      ],
      "values": [
        "red",
        "Youth M"
      ],
      "mediaId": "33461205401790"
    },
    {
      "id": "47904017973438",
      "title": "red / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "red"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "red",
        "Youth L"
      ],
      "mediaId": "33461205401790"
    },
    {
      "id": "47904018006206",
      "title": "red / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "red"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "red",
        "Youth XL"
      ],
      "mediaId": "33461205401790"
    },
    {
      "id": "47904018038974",
      "title": "Yellow / Youth XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Yellow"
        },
        {
          "name": "Size",
          "value": "Youth XS"
        }
      ],
      "values": [
        "Yellow",
        "Youth XS"
      ],
      "mediaId": "33461205434558"
    },
    {
      "id": "47904018071742",
      "title": "Yellow / Youth S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Yellow"
        },
        {
          "name": "Size",
          "value": "Youth S"
        }
      ],
      "values": [
        "Yellow",
        "Youth S"
      ],
      "mediaId": "33461205434558"
    },
    {
      "id": "47904018104510",
      "title": "Yellow / Youth M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Yellow"
        },
        {
          "name": "Size",
          "value": "Youth M"
        }
      ],
      "values": [
        "Yellow",
        "Youth M"
      ],
      "mediaId": "33461205434558"
    },
    {
      "id": "47904018137278",
      "title": "Yellow / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Yellow"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Yellow",
        "Youth L"
      ],
      "mediaId": "33461205434558"
    },
    {
      "id": "47904018170046",
      "title": "Yellow / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Yellow"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Yellow",
        "Youth XL"
      ],
      "mediaId": "33461205434558"
    }
  ],
  "singleVariant": false,
  "colorSwatches": {},
  "optimizeColorSwatches": false
};
  var applying = false;
  function root() {
    return document.querySelector('.auto-product[data-product-handle="' + config.handle + '"]');
  }
  function absolute(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }
  function sized(url, width) {
    try {
      var parsed = new URL(absolute(url), window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return absolute(url);
    }
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function selectedValues(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('input[name^="options["]:checked')).map(function (input) {
      return input.value || '';
    });
  }
  function selectedEntry(scope) {
    var selectedColor = scope.querySelector('input[name="options[Color]"]:checked');
    var exactColorMediaId = selectedColor && config.colorSwatches ? config.colorSwatches[selectedColor.value] : '';
    if (exactColorMediaId) {
      var exactColorEntry = config.entries.find(function (entry) { return entry.id === exactColorMediaId; });
      if (exactColorEntry) return exactColorEntry;
    }
    var values = selectedValues(scope);
    var variant = config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    });
    return variant ? config.entries.find(function (entry) { return entry.id === variant.mediaId; }) : null;
  }
  function selectedVariant(scope) {
    var values = selectedValues(scope);
    return config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    }) || null;
  }
  function syncPurchase(scope) {
    var variant = selectedVariant(scope);
    if (!variant) return;
    scope.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (field) {
      if (String(field.value || '') !== String(variant.id)) {
        field.value = variant.id;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    scope.querySelectorAll('form[action*="/cart/add"] button[type="submit"]').forEach(function (button) {
      button.disabled = !variant.availableForSale;
      button.setAttribute('aria-disabled', variant.availableForSale ? 'false' : 'true');
      var label = button.querySelector('span') || button;
      if (variant.availableForSale && /solds*out|unavailable/i.test(label.textContent || '')) label.textContent = 'Add to Cart';
      if (!variant.availableForSale && /adds*tos*cart/i.test(label.textContent || '')) label.textContent = 'Sold Out';
    });
  }
  function setMain(scope, entry) {
    var main = scope.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function syncVisualChoices(scope) {
    scope.querySelectorAll('.auto-product__choice--visual').forEach(function (choice) {
      var input = choice.querySelector('input[name^="options["]');
      if (!input) return;
      var optionMatch = String(input.name || '').match(/^options\[(.+)\]$/);
      if (!optionMatch) return;
      var optionName = optionMatch[1];
      var exactColorMediaId = optionName === 'Color' && config.colorSwatches ? config.colorSwatches[input.value] : '';
      var mediaIds = exactColorMediaId ? [exactColorMediaId] : config.variants.filter(function (variant) {
        return (variant.options || []).some(function (option) {
          return option.name === optionName && option.value === input.value;
        });
      }).map(function (variant) { return variant.mediaId; }).filter(Boolean).filter(function (id, index, all) {
        return all.indexOf(id) === index;
      });
      if (mediaIds.length !== 1) return;
      var entry = config.entries.find(function (item) { return item.id === mediaIds[0]; });
      if (!entry) return;
      var swatch = choice.querySelector('.auto-product__swatch-image');
      if (!swatch) {
        swatch = document.createElement('span');
        swatch.className = 'auto-product__swatch-image';
        swatch.setAttribute('aria-label', input.value || entry.alt || '');
        (choice.querySelector('[data-auto-choice-label]') || choice).appendChild(swatch);
      }
      var image = swatch.querySelector('img');
      if (!image) {
        image = document.createElement('img');
        image.width = 72;
        image.height = 72;
        image.loading = 'lazy';
        swatch.appendChild(image);
      }
      image.src = sized(entry.src, 180);
      image.srcset = '';
      image.alt = input.value || entry.alt || '';
      choice.setAttribute('data-variant-media-id', entry.id);
    });
  }
  function ensureScopedStyles(scope) {
    if (!config.optimizeColorSwatches || document.getElementById('sps5-gallery-swatch-layout-20260716')) return;
    var style = document.createElement('style');
    style.id = 'sps5-gallery-swatch-layout-20260716';
    style.textContent = [
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__thumbs{display:flex!important;visibility:visible!important;opacity:1!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__thumb{display:grid!important;visibility:visible!important;opacity:1!important;flex:0 0 auto;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choices{display:grid!important;grid-template-columns:repeat(6,minmax(58px,1fr));gap:10px;width:100%;overflow:visible;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choice--visual{width:100%;min-width:0;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choice--visual>[data-auto-choice-label]{width:100%!important;min-width:0!important;height:auto!important;min-height:0!important;aspect-ratio:1/1;display:flex!important;align-items:center!important;justify-content:center!important;overflow:hidden!important;background:#fff!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image,.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image img{width:100%!important;height:100%!important;display:block!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image img{object-fit:contain!important;object-position:center!important;background:#fff!important;padding:3px!important;box-sizing:border-box!important;}',
      '@media(max-width:640px){.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choices{grid-template-columns:repeat(3,minmax(64px,1fr));gap:10px;}}'
    ].join('');
    document.head.appendChild(style);
  }
  function syncSingleVariantLegend(scope) {
    if (!config.singleVariant) return;
    scope.querySelectorAll('.auto-product__option legend').forEach(function (legend) {
      legend.style.setProperty('justify-content', 'flex-start', 'important');
      legend.style.setProperty('align-items', 'center', 'important');
      legend.style.setProperty('gap', '16px', 'important');
      legend.style.setProperty('width', 'fit-content', 'important');
      legend.style.setProperty('max-width', '100%', 'important');
    });
  }
  function ensureThumb(scope, wrap, entry, index) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
      wrap.appendChild(thumb);
    }
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.setAttribute('aria-hidden', 'false');
    thumb.hidden = false;
    thumb.style.display = '';
    if (!thumb.querySelector('img')) {
      thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="lazy">';
    }
    if (thumb.dataset.motorbikeGalleryBound !== 'true') {
      thumb.dataset.motorbikeGalleryBound = 'true';
      thumb.addEventListener('click', function () {
        setMain(scope, entry);
        scope.querySelectorAll('[data-auto-thumb]').forEach(function (node) {
          node.classList.toggle('is-active', node === thumb);
        });
      });
    }
    return thumb;
  }
  function hydrate() {
    if (applying) return;
    var scope = root();
    if (!scope) return;
    var wrap = scope.querySelector('.auto-product__thumbs');
    if (!wrap) return;
    applying = true;
    var desiredSafeIds = '|' + config.entries.map(function (entry) { return entry.id; }).join('|') + '|';
    if (scope.getAttribute('data-safe-gallery-media-ids') !== desiredSafeIds) {
      scope.setAttribute('data-safe-gallery-media-ids', desiredSafeIds);
    }
    ensureScopedStyles(scope);
    config.entries.forEach(function (entry, index) { ensureThumb(scope, wrap, entry, index); });
    scope.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      thumb.hidden = false;
      thumb.style.display = '';
      thumb.setAttribute('aria-hidden', 'false');
    });
    syncVisualChoices(scope);
    syncSingleVariantLegend(scope);
    syncPurchase(scope);
    setMain(scope, selectedEntry(scope));
    applying = false;
  }
  function run() {
    var scope = root();
    if (!scope) return;
    hydrate();
    if (scope.dataset.motorbikeBackpackGalleryRestoreBound === 'true') return;
    scope.dataset.motorbikeBackpackGalleryRestoreBound = 'true';
    scope.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches('input[name^="options["]')) return;
      [0, 80, 250, 700, 1400].forEach(function (delay) {
        window.setTimeout(function () {
          hydrate();
          setMain(scope, selectedEntry(scope));
          syncPurchase(scope);
        }, delay);
      });
    });
    var observer = new MutationObserver(function (records) {
      if (applying) return;
      var changed = records.some(function (record) { return record.addedNodes.length || record.removedNodes.length; });
      if (changed) window.setTimeout(hydrate, 20);
    });
    observer.observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-safe-gallery-media-ids'] });
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  [150, 500, 1300, 3000, 6000, 10000].forEach(function (delay) { window.setTimeout(hydrate, delay); });
  window.setInterval(hydrate, 1200);
})();
// END motorbikeBackpackGalleryRestore20260716
